import { ClareStatusColors, ClareStatuses } from "@app/shared/model/clare-status.model";
import { ClassImporterExporter, ImportMap } from "@app/shared/resources/class-importer-exporter.service";
import { ProjectAndRelatedData } from "./project";

export interface CentralStationProject {
    id?: string;
    dealerId: string;
    name: string;
    address: string;
    uuid?: string;
    macAddress?: string;
    upgradeStatus?: [ClareStatuses.Yes, ClareStatusColors.Yes] | [ClareStatuses.NotUpgraded, ClareStatusColors.NotUpgraded];
}

/* eslint-disable @typescript-eslint/naming-convention */
interface CentralStationProjectData {
    id?: string;
    dealerId: string;
    name: string;
    address: string;
    uuid?: string;
    mac_address?: string;
}

export class CentralStationProjectHelper {
    static readonly importMap: ImportMap<CentralStationProject, CentralStationProjectData> = [
        { i: "id", o: "id" },
        { i: "dealerId", o: "dealerId", skipExport: true },
        { i: "name", o: "name", skipExport: true },
        { i: "address", o: "address" },
        { i: "uuid", o: "uuid" },
        { i: "mac_address", o: "macAddress" },
    ];

    static fromDbObject(dbObject): CentralStationProject {
        const project = dbObject?.project[0];
        const centralStationProject = ClassImporterExporter.importObject(dbObject, this.importMap);
        centralStationProject.name = project?.userinfo?.last_name + ", " + project?.userinfo?.first_name;
        centralStationProject.macAddress = dbObject?.mac_address;
        centralStationProject.address = project?.address?.address;
        centralStationProject.uuid = project?.claresystem?.uuid;
        // centralStationProject.id = dbObject.id;
        return centralStationProject;
    }

    static fromProjectAndRelatedData(dbObject: ProjectAndRelatedData): CentralStationProject {
        const projectAndRelatedData = new ProjectAndRelatedData(dbObject);
        const userinfo = projectAndRelatedData.getPrimaryUserInfo();
        const address = projectAndRelatedData.getParsedAddress();
        const securitySystem = projectAndRelatedData.getParsedSecuritySystem();
        const claresystem = projectAndRelatedData.getParsedClareSystem();
        const centralStationProject: CentralStationProject = {
            dealerId: `${userinfo.entityId}`,
            address: address.address,
            macAddress: securitySystem.macAddress,
            name: `${userinfo.lastName}, ${userinfo.firstName}`,
            uuid: claresystem.uuid,
        };
        return centralStationProject;
    }

    static toDbObject(receiver: CentralStationProject): Partial<CentralStationProjectData> {
        return ClassImporterExporter.exportObject(receiver, this.importMap);
    }
}
